import React from "react";
import "./title.css";

export const Title = (props) => {
    var className = "";
    if (props.card) className = "cmis-card";
    else if (props.table) className = "cmis-table-title";

    return (
        <h1 id={props.id} className={"title " + className}>
            {props.children}
        </h1>
    );
};
